import React from "react";
import { Link } from "react-router-dom";
import "./EmptyStates.scss";

const EmptyStates = (props) => {
  const { imgSrc, emptyStateTitle, breakLine, emptyStateButtons, description } = props;
  //break lines
  const lines = emptyStateTitle.split(breakLine);

  const getContentRole = (userRoleId) => {
    if (props.match.path === "/files/:folderId") {
      const folder = props.rootFolders.find(
        (rootFolder) => rootFolder.id === props.match.params.folderId
      );
      if (userRoleId === 1 || userRoleId === 2) {
        return true;
      } else if (folder) {
        const createUserId = folder.createdBy.id;
        const logUserId = props.currentUserInfo.id;
        let returnedVal;
        if (logUserId === createUserId) {
          returnedVal = true;
        } else {
          const sharedUsers = folder.sharedFolder.map((sharedItem) => {
            return {
              id: sharedItem.user.id,
              role: sharedItem.userRole.name,
            };
          });
          const getAccess = sharedUsers.find(
            (sharedUser) =>
              sharedUser.id === logUserId &&
              (sharedUser.role === "Owner" ||
                sharedUser.role === "Collaborator")
          );
          returnedVal = getAccess ? true : false;
        }
        return returnedVal;
      }
    } else if (props.match.path === "/files/:folderId/:subId") {
      const folder =
        props.subFolders[props.match.params.folderId] &&
        props.subFolders[props.match.params.folderId].find(
          (rootFolder) => rootFolder.id === props.match.params.subId
        );
      if (userRoleId === 1 || userRoleId === 2) {
        return true;
      } else if (folder) {
        const createUserId = folder.createdBy.id;
        const logUserId = props.currentUserInfo.id;
        let returnedVal;
        if (logUserId === createUserId) {
          returnedVal = true;
        } else {
          const sharedUsers = folder.sharedFolder.map((sharedItem) => {
            return {
              id: sharedItem.user.id,
              role: sharedItem.userRole.name,
            };
          });
          const getAccess = sharedUsers.find(
            (sharedUser) =>
              sharedUser.id === logUserId &&
              (sharedUser.role === "Owner" ||
                sharedUser.role === "Collaborator")
          );
          returnedVal = getAccess ? true : false;
        }
        return returnedVal;
      }
    } else {
      return true;
    }
  };

  return (
    <div className="empty-states">
      <div className="empty-states-image">
        <img src={imgSrc} alt="Empty screen icon" />
      </div>
      <div className="h5 empty-states-heading">
        {lines[0]}
        <br />
        {`${breakLine ? breakLine : ""} ${lines[1] ? lines[1] : ""}`}
      </div>
      {
        description ? (<div className=" empty-states-description">{description}</div>) : null
      }
      
      <div className="empty-states-buttons">
        {emptyStateButtons.map((item, index) => {
          return (
            <div
              key={index}
              className={
                emptyStateButtons.length > 1 && index === 0
                  ? "first-btn"
                  : "second-btn"
              }
            >
              {item.link ? (
                getContentRole(props.userRoleId) ? (
                  <Link
                    to={"/files/".concat(
                      props.match.params.folderId,
                      "/",
                      props.match.params.subId,
                      "/bulk-upload"
                    )}
                  >
                    <button
                      className={index === 0 ? `btn-primary` : "btn-secondary"}
                      onClick={item.clickMethod}
                      data-toggle={item.buttonToggle}
                      data-target={item.buttonTarget}
                    >
                      {item.buttonName}
                    </button>
                  </Link>
                ) : null
              ) : getContentRole(props.userRoleId) ? (
                <button
                  className={index === 0 ? `btn-primary` : "btn-secondary"}
                  onClick={item.clickMethod}
                  data-toggle={item.buttonToggle}
                  data-target={item.buttonTarget}
                >
                  {item.buttonName}
                </button>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmptyStates;
